<template>
    <div class="row my-4">
      <div class="col-12 pb-5">
          <router-link
            :to="{
              name: 'list',
              query: { store: this.$route.query.store , category:data[0].category_id,
              name:data[0].category_name,
              isFromStore:true
              },
              params: {
                menu_url_key: `store-${$route.query.store}`
              }
            }"
			>
          <img :src="data[0].img_path" class="img-fluid" alt="">

            <a v-if="data[0].category_name.length > 2" href="#" class="grid-2-btn">
              {{ data[0].category_name }}
            </a>

          </router-link>
        </div>
      </div>

</template>
<script>
export default {
    props:['data']
}
</script>